export enum AddressFieldLabel {
  NAME = 'Name',
  FREE_TEXT1 = 'Freitextfeld 1',
  FREE_TEXT2 = 'Freitextfeld 2'
}


export enum MapAddressField {
  NAME = 'address_line_2',
  FREE_TEXT1 = 'address_line_3',
  FREE_TEXT2 = 'sap_name'
}
